var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.317 21C14.0783 20.9377 12.8029 20.4561 11.5814 19.7974C8.72674 18.2576 6.3473 16.0951 4.24347 13.5823C2.84823 11.9154 1.64872 10.1098 0.798421 8.06875C0.39441 7.10401 0.093751 6.10645 0.0154543 5.05312C-0.0628423 3.99978 0.143859 3.05473 0.923694 2.30165C1.46081 1.78318 1.958 1.22042 2.47867 0.683905C3.33994 -0.202899 4.50264 -0.236534 5.37016 0.637145C6.29093 1.56497 7.19056 2.5174 8.08236 3.47639C8.31189 3.71034 8.48054 4.00187 8.57233 4.32331C8.66411 4.64474 8.67597 4.98541 8.60679 5.313C8.53761 5.64059 8.38967 5.94421 8.17703 6.19507C7.96438 6.44592 7.69409 6.63568 7.39179 6.74633C6.31599 7.13846 5.90415 8.11058 6.25492 9.24349C6.70512 10.7045 7.62276 11.8309 8.69777 12.8268C9.42201 13.4979 10.2112 14.0713 11.1453 14.3855C12.1851 14.7366 13.2147 14.2985 13.5592 13.2189C13.9452 12.0105 15.5675 11.3067 16.7388 12.538C17.6228 13.4675 18.5185 14.3847 19.3923 15.3272C20.2074 16.2034 20.2003 17.4462 19.3845 18.3314C18.7957 18.9704 18.192 19.5939 17.5837 20.2182C16.9949 20.8154 16.2628 20.9984 15.317 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.16f51643fff01d92c044de76d5e8bf2b.svg";
export { ForwardRef as ReactComponent };